import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import { ErrorSnacktOpen } from "../../ErrorSnack/actions";

export const OpenSolicitudEditarCreacion = (modalAction, detalleSolicitudSol) => ({
  type: "OPEN_SOLICITUD_EDITAR_CREACION",
  modalAction,
  detalleSolicitudSol,
});

export const CambiarMontoArancelPrestacion = (montoArancelPrestacion, error) => ({
  type: "SOLEDIT_CREACION/CAMBIAR_MONTO_ARANCEL_PRESTACION",
  montoArancelPrestacion,
  error,
});

export const CambiarTipoUnidad = (tipoUnidad, error) => ({
  type: "SOLEDIT_CREACION/CAMBIAR_TIPO_UNIDAD",
  tipoUnidad,
  error,
});

export const CambiarCodigoPrestacionPrestador = (codigoPrestacionPrestador, error) => ({
  type: "SOLEDIT_CREACION/CAMBIAR_CODIGO_PRESTACION_PRESTADOR",
  codigoPrestacionPrestador,
  error,
});

export const CambiarPabellonPrestacion = (pabellonPrestacion, error) => ({
  type: "SOLEDIT_CREACION/CAMBIAR_PABELLON_PRESTACION",
  pabellonPrestacion,
  error,
});

export const CambiarGlosaPrestacionPrestador = (glosaPrestacionPrestador, error) => ({
  type: "SOLEDIT_CREACION/CAMBIAR_GLOSA_PRESTACION_PRESTADOR",
  glosaPrestacionPrestador,
  error,
});

export const CambiarCodigoFonasa = (codigoFonasa, error) => ({
  type: "SOLEDIT_CREACION/CAMBIAR_CODIGO_FONASA",
  codigoFonasa,
  error,
});

export const CambiarItemImed = (itemImed, error) => ({
  type: "SOLEDIT_CREACION/CAMBIAR_ITEM_IMED",
  itemImed,
  error,
});

export const CambiarTipoProfesional = (tipoProfesional, error) => ({
  type: "SOLEDIT_CREACION/CAMBIAR_TIPO_PROFESIONAL",
  tipoProfesional,
  error,
});

export const CambiarInicioVigenciaArancel = (inicioVigenciaArancel, error) => ({
  type: "SOLEDIT_CREACION/CAMBIAR_INICIO_VIGENCIA_ARANCEL",
  inicioVigenciaArancel,
  error,
});

export const CambiarTipoPrestacion = (tipoPrestacion, error) => ({
  type: "SOLEDIT_CREACION/CAMBIAR_TIPO_PRESTACION",
  tipoPrestacion,
  error,
});

export const CambiarPertenenciaFonasa = (pertenenciaFonasa, error) => ({
  type: "SOLEDIT_CREACION/CAMBIAR_PERMANENCIA_FONASA",
  pertenenciaFonasa,
  error,
});

export const ValidarGuarismo = (validar) => ({
  type: "SOLEDIT_CREACION/VALIDAR_GUARISMO",
  validar,
});

export const LimpiarCodIsapreFonasa = (error) => ({
  type: "SOLEDIT_CREACION/CLEAR_CODIGO_FONASA",
  error,
});

export const LoadingValidaCodIsapreFonasa = (isLoad) => ({
  type: "SOLEDIT_CREACION/LOADING_VALIDACION_CODIGO_FONASA",
  isLoad,
});

export const SetValidaCodIsapreFonasa = (valid) => ({
  type: "SOLEDIT_CREACION/SET_VALIDACION_CODIGO_FONASA",
  valid,
});


// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const validaCodIsapreFonasa = () => (dispatch) => {
  const globalState = store.getState().global;
  const solicitudEditarCreacionState = store.getState().solicitudEditarCreacion;
  const params = {
    CodFonasa: solicitudEditarCreacionState.detallePrestacion.codigoFonasa,
    Isapre: globalState.isapre,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/prestaciones/validaCodIsapreFonasa/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      //trace.information("validaCodIsapreFonasa", json);
      let codigoValido = false;
      if (json && json.Existe && json.Existe === "S") {
        codigoValido = true;
      }
      dispatch(SetValidaCodIsapreFonasa(codigoValido));
      dispatch(LoadingValidaCodIsapreFonasa(false));
    })
    .catch((error) => {
      trace.error("validaCodIsapreFonasa", error);
      dispatch(ErrorSnacktOpen(
        "Error al válidar código fonasa:",
        error,
      ));
    });
};



// WEBPACK FOOTER //
// ./src/components/ActualizarArancel/SolicitudEditarCreacion/actions.js